import { Enumeration } from '../../../../../common/types';
import { AdviserItem, AfslItem, ModelItem, PracticeItem, SecurityItem } from '../../../common/store/types';

export interface AccountSearchResult {
  clientId: number;
  clientName: string;
  clientType: string;
  email: string;
}

export interface EmailSearchState {
  parameters: AccountSearchParameters;
  models: ModelItem[];
  accountSearchResult: AccountSearchResult[];
  accountSelected: AccountSearchResult[];
}

export interface AccountSearchParameters {
  afsls: AfslItem[];
  practices: PracticeItem[];
  advisers: AdviserItem[];
  accountType: string[];
  serviceTypeId: number | null;
  portfolioValueFrom: number | null;
  portfolioValueTo: number | null;
  availableCashBalanceFrom: number | null;
  availableCashBalanceTo: number | null;
  securityHeld: string;
  security: SecurityItem | null;
  securitySearch: string | null;
  includeZeroHoldings: boolean;
  model: ModelItem | null;
}

export class SecurityHeld extends Enumeration {
  static Held = new SecurityHeld(1, 'Held', 'Hold');
  static NotHeld = new SecurityHeld(2, 'NotHeld', "Doesn't hold");
}
